/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { ESignModal } from '../common/SharedComponents';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import store, { bfiUserActions, userActions } from '@apply/adminStore';
import { TemplatesApi, UsersApi, LoginApi } from '@apply/api';
import { applicationInsights } from '../ApplicationInsights';
import LoadPanel from 'devextreme-react/load-panel';
import { handleAdminError, handleAdminSuccess } from '../common/SharedFunctions';
import { SectionHeader } from '../common/SharedComponents';
import { useNavigate } from 'react-router-dom';
import { UserAgreementType } from '@apply/constants';

const AdminSignAgreement = () => {
    const { bfiUser, user } = useSelector((state) => state);
    const navigate = useNavigate();
    const { dispatch } = store;
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);
    const usersApi = new UsersApi.UsersApi(applicationInsights);
    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const [eSignElecTerms, set_eSignElecTerms] = useState(false);
    const [eSignElecTermsFont, set_elecTermsFont] = useState();
    const [openESignElecTermsModal, set_openESignElecTermsModal] = useState(false);

    const [eSignAdminTerms, set_eSignAdminTerms] = useState(false);
    const [eSignAdminTermsFont, set_eSignAdminTermsFont] = useState();
    const [openESignAdminTermsModal, set_openESignAdminTermsModal] = useState(false);

    const [loadingMessage, set_loadingMessage] = useState('');
    const [elecTermsHtml, set_elecTermsHtml] = useState('');
    const [adminTermsHtml, set_adminTermsHtml] = useState('');

    useEffect(() => {
        const eSignElecTermsCheckbox = document.getElementById('eSignElecTerms');
        if (eSignElecTermsCheckbox) {
            eSignElecTermsCheckbox.checked = eSignElecTerms;
        }
    }, [eSignElecTerms]);

    useEffect(() => {
        const getUserAgreementsHtmlAsync = async () => {
            if (!elecTermsHtml) {
                const html = await getEsignHtml(UserAgreementType.ElectronicRecordsAndDisclosures);
                set_elecTermsHtml(html);
            }
            if (!adminTermsHtml) {
                const html = await getEsignHtml(UserAgreementType.AdminTermsAndConditions);
                set_adminTermsHtml(html);
            }
        };
        getUserAgreementsHtmlAsync();
    }, []);

    const getEsignHtml = async (agreementId) => {
        try {
            set_loadingMessage('Retrieving User Agreements...');
            const response = await templatesApi.getUserAgreementHtml(agreementId);
            if (response.statusCode !== 200) {
                return '';
            }
            return response.result;
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error occured attempting to get the User Agreement. Please try again.');
        } finally {
            set_loadingMessage('');
        }
    };

    const onElecTermsCheck = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const checkBox = document.getElementById('eSignElecTerms');
        if (checkBox) {
            checkBox.checked = eSignElecTerms;
        }
        set_openESignElecTermsModal(true);
    };

    const onAdminTermsCheck = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const checkBox = document.getElementById('eSignAdminTerms');
        if (checkBox) {
            checkBox.checked = eSignAdminTerms;
        }
        set_openESignAdminTermsModal(true);
    };

    const _handleElecTermsModalConfirm = (font) => {
        set_elecTermsFont(font.key);
        set_eSignElecTerms(true);
        set_openESignElecTermsModal(false);
    };

    const _handleElecTermsModalCancel = () => {
        set_eSignElecTerms(false);
        set_openESignElecTermsModal(false);
    };

    const _handleAdminTermsModalConfirm = (font) => {
        set_eSignAdminTermsFont(font.key);
        set_eSignAdminTerms(true);
        set_openESignAdminTermsModal(false);
    };

    const _handleAdminTermsModalCancel = () => {
        set_eSignAdminTerms(false);
        set_openESignAdminTermsModal(false);
    };

    const _onSubmit = async (event) => {
        event.preventDefault();

        let ipAddressResult = '';
        const ipAddressResponse = await loginApi.getIpAddress();
        if (ipAddressResponse.statusCode === 200) {
            ipAddressResult = ipAddressResponse.result;
        }

        if (bfiUser.requiresESign) {
            const model = {
                userId: bfiUser.userId,
                fontId: parseInt(eSignElecTermsFont),
                userAgreementTypeId: UserAgreementType.ElectronicRecordsAndDisclosures,
                ipAddress: ipAddressResult,
            };
            await saveAgreement(model);

            bfiUser.areTermsAccepted = true;
            bfiUser.requiresESign = false;
            dispatch(bfiUserActions.bfiUserUpdate(bfiUser));
            user.requiresESign = false;
            dispatch(userActions.userUpdate(user));
        }

        if (bfiUser.requiresAdminTermsESign) {
            const model = {
                userId: bfiUser.userId,
                fontId: parseInt(eSignAdminTermsFont),
                userAgreementTypeId: UserAgreementType.AdminTermsAndConditions,
                ipAddress: ipAddressResult,
            };
            await saveAgreement(model);

            bfiUser.areTermsAccepted = true;
            bfiUser.requiresAdminTermsESign = false;
            dispatch(bfiUserActions.bfiUserUpdate(bfiUser));
            user.requiresAdminTermsESign = false;
            dispatch(userActions.userUpdate(user));
        }
        navigate('/adminreferral');
    };

    const saveAgreement = async (model) => {
        try {
            set_loadingMessage('Saving Consent...');
            await usersApi.signUserAgreement(model);
            handleAdminSuccess('Consent saved sucessfully.');
        } catch {
            handleAdminError(ex, 'An unexpected error occurred! Please try again');
        } finally {
            set_loadingMessage('');
        }
    };

    const styles = {
        buttonMarginRight: {
            marginRight: '20px',
        },
        checkbox: {
            textAlign: 'center',
            width: '30px',
            float: 'left',
        },
        checkboxText: {
            width: '800px',
            float: 'left',
        },
        checkboxLabel: {
            width: '90%',
        },
        innerPageStyle: {
            maxWidth: '996px',
            margin: '0 auto',
        },
        clear: {
            clear: 'both',
        },
    };
    return (
        <>
            <SectionHeader title='User Agreement' />
            <div className='main-content'>
                <form
                    name='signForm'
                    onSubmit={(event) => _onSubmit(event)}
                >
                    <div className='main-content no-search'>
                        <div className='scrollable-content'>
                            <div
                                className='standard-form'
                                style={styles.innerPageStyle}
                            >
                                <div
                                    className='row'
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className='columns small-12 large-12'>
                                        <b>In order to to use this website you must agree to the terms.</b>
                                        <br />
                                        <br /> Please click the consent checkbox(es) below to sign the agreement(s).
                                    </div>
                                </div>
                                <div></div>
                                <div style={styles.clear}></div>
                                {bfiUser.requiresESign && (
                                    <div style={styles.clear}>
                                        <div style={styles.checkbox}>
                                            <input
                                                id='eSignElecTerms'
                                                type='checkbox'
                                                checked={eSignElecTerms}
                                                onChange={(event) => onElecTermsCheck(event)}
                                            />
                                        </div>
                                        <div style={styles.checkboxText}>
                                            <label htmlFor='eSignElecTerms'>
                                                Consent to Use Electronic Records and Disclosures. By checking this check box and
                                                clicking "SAVE", I acknowledge that I have read and agree to the Consent to Use
                                                Electronic Records and Disclosures
                                            </label>
                                        </div>
                                    </div>
                                )}
                                {bfiUser.requiresAdminTermsESign && (
                                    <div style={styles.clear}>
                                        <div style={styles.checkbox}>
                                            <input
                                                id='eSignAdminTerms'
                                                type='checkbox'
                                                checked={eSignAdminTerms}
                                                onChange={(event) => onAdminTermsCheck(event)}
                                            />
                                        </div>
                                        <div style={styles.checkboxText}>
                                            <label htmlFor='eSignAdminTerms'>Consent to Admin Terms and Conditions</label>
                                        </div>
                                    </div>
                                )}
                                <div style={styles.clear}>
                                    <div
                                        className='button-footer'
                                        style={styles.innerPageStyle}
                                    >
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                            disabled={
                                                (bfiUser.requiresESign && !eSignElecTerms) ||
                                                (bfiUser.requiresAdminTermsESign && !eSignAdminTerms)
                                            }
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <ESignModal
                isOpen={openESignElecTermsModal}
                confirmCallback={(font) => _handleElecTermsModalConfirm(font)}
                cancelCallback={() => _handleElecTermsModalCancel()}
                signatureText={`${bfiUser.firstName} ${bfiUser.lastName}`}
                agreementHtml={elecTermsHtml}
            />
            <ESignModal
                isOpen={openESignAdminTermsModal}
                confirmCallback={(font) => _handleAdminTermsModalConfirm(font)}
                cancelCallback={() => _handleAdminTermsModalCancel()}
                signatureText={`${bfiUser.firstName} ${bfiUser.lastName}`}
                agreementHtml={adminTermsHtml}
            />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={!!loadingMessage}
                message={loadingMessage}
            />
        </>
    );
};

export default AdminSignAgreement;
